import { useAuth0 } from "@auth0/auth0-react";
import { FcGoogle } from "react-icons/fc";

const LoginButton = () => {
	const { loginWithRedirect } = useAuth0();

	return <button className="text-center flex w-full p-5 border border-gray-600 rounded-xl" onClick={() => loginWithRedirect()}>
		<FcGoogle className="text-3xl" /><p className="ml-3 text-center">Iniciar Sesión con Google</p></button>;
};

export default LoginButton;